export function initializeMobileNav() {
    var hamburgerButton = document.querySelector(".hamburger"),
        mobileNav = document.querySelector(".mobile-nav .nav"),
        mobileNavClose = document.querySelector(".nav__close"),
        pageOverlayNav = document.querySelector(".page-overlay--nav");

    function isOutsideNav(target) {
        return !mobileNav.contains(target) && !hamburgerButton.contains(target);
    }

    document.addEventListener("click", function(event) {
        if (isOutsideNav(event.target)) {
            mobileNav.classList.remove("nav--open");
            pageOverlayNav.classList.remove("page-overlay--active");
        }
    });

    hamburgerButton.addEventListener("click", function() {
        hamburgerButton.classList.toggle("hamburger--active");
        mobileNav.classList.toggle("nav--open");
        pageOverlayNav.classList.toggle("page-overlay--active");
    });

    mobileNavClose.addEventListener("click", function() {
        hamburgerButton.classList.remove("hambuger--active");
        mobileNav.classList.remove("nav--open");
        pageOverlayNav.classList.remove("page-overlay--active");
    });
}